import { get } from 'lodash';
import * as Constants from '../../constants';

const resetState = {
  isError: false,
  errors: [],
};
const initialState = {
  ...resetState,
  isLoading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Constants.KEY_SETTINGS_GET_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        errors: [],
      };
    case Constants.KEY_SETTINGS_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        data: action.payload,
      };
    case Constants.KEY_SETTINGS_GET_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
      };
    case Constants.KEY_SETTINGS_UPDATE_REQUEST:
      return {
          ...state,
          isLoading: true,
          isError: false,
          errors: [],
          errorFields: [],
          updateKeySettingsStatus: '',
      };
    case Constants.KEY_SETTINGS_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        updateKeySettingsStatus: Constants.SUCCESS,
      };
    case Constants.KEY_SETTINGS_UPDATE_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload.message,
        errorFields: action.payload.errorFields,
        updateKeySettingsStatus: Constants.FAIL,
      };
    case Constants.EXECUTE_EXPIRY_JOB_REQUEST:
      return {
        ...state,
        expiryJobStatus: Constants.NONE,
        isExecutingExpiryJob: true,
      };
    case Constants.EXECUTE_EXPIRY_JOB_SUCCESS:
      return {
        ...state,
        expiryJobStatus: Constants.SUCCESS,
        isExecutingExpiryJob: false,
      };
    case Constants.EXECUTE_EXPIRY_JOB_ERROR:
      return {
        ...state,
        expiryJobStatus: Constants.FAIL,
        isExecutingExpiryJob: false,
      };
    case Constants.EXECUTE_EXPIRY_REPORTING_JOB_REQUEST:
      return {
        ...state,
        reportingJobStatus: Constants.NONE,
        isExecutingReportingJob: true,
      };
    case Constants.EXECUTE_EXPIRY_REPORTING_JOB_SUCCESS:
      return {
        ...state,
        reportingJobStatus: Constants.SUCCESS,
        isExecutingReportingJob: false,
      };
    case Constants.EXECUTE_EXPIRY_REPORTING_JOB_ERROR:
      return {
        ...state,
        reportingJobStatus: Constants.FAIL,
        isExecutingReportingJob: false,
      };
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'apiKeySettings.isLoading');

export const getIsError = (state) => get(state, 'apiKeySettings.isError');

export const getErrors = state => get(state, 'apiKeySettings.errors');

export const getErrorFields = state => get(state, 'apiKeySettings.errorFields');

export const getAPIKeySettings = state => get(state, 'apiKeySettings.data');

export const getIsExecutingExpiryJob = state => get(state, 'apiKeySettings.isExecutingExpiryJob');

export const getExpiryJobStatus = state => get(state, 'apiKeySettings.expiryJobStatus');

export const getIsExecutingReportingJob = state => get(state, 'apiKeySettings.isExecutingReportingJob');

export const getReportingJobStatus = state => get(state, 'apiKeySettings.reportingJobStatus');

export const getUpdateKeySettingsStatus = state => get(state, 'apiKeySettings.updateKeySettingsStatus');
